import { useTranslation } from 'react-i18next';
import { contentPushed } from 'features/layout/features/content/actions';
import { usePermissions } from 'features/permissions/usePermissions';
import { PermissionTypes } from 'features/permissions/types';
import { selectShowAllScreens } from 'features/screenshare/screenshareSlice';
import {
  selectCurrentContentId,
  selectGridPanel,
  selectLockedContent,
} from 'features/layout/features/content/contentSlice';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { selectContentLibraryOpenedFile } from 'features/content-library/contentLibrarySlice';
import { selectWhiteboardOpen } from 'features/whiteboard/whiteboardSlice';
import { isPrivateWhiteboard } from 'features/content-library/utils/isPrivateWhiteboard';
import { openModal } from 'features/modal/modalSlice';

export const usePushContentControl = () => {
  const { hasPermissions } = usePermissions();
  const { t } = useTranslation('room');
  const dispatch = useAppDispatch();

  const hasPushContentPermission = hasPermissions(PermissionTypes.pushContent);

  const showAllScreens = useAppSelector(selectShowAllScreens);
  const currentGridPanel = useAppSelector(selectGridPanel);
  const lockedContent = useAppSelector(selectLockedContent);
  const currentContentId = useAppSelector(selectCurrentContentId);

  const isWhiteboardOpen = useAppSelector(selectWhiteboardOpen);

  const openedFile = useAppSelector(selectContentLibraryOpenedFile);

  const privateWhiteboard = isWhiteboardOpen && isPrivateWhiteboard(openedFile);

  const controlEnabled =
    hasPushContentPermission &&
    !privateWhiteboard &&
    lockedContent?.id !== currentContentId &&
    (!showAllScreens || currentGridPanel !== 'screenshare');

  const handleClick = () => {
    if (controlEnabled) {
      if (lockedContent && currentContentId !== lockedContent.id) {
        dispatch(openModal('lockContentConfirm', { action: 'push' }));
        return;
      }

      dispatch(contentPushed());
    }
  };

  return {
    label: t('grid.push_content'),
    tooltip: t('tooltips.push_content'),
    handleClick,
    controlEnabled,
  };
};
